"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAttributesDtoOtherAreaUnitEnum = exports.PropertyAttributesDtoMezzanineAreaUnitEnum = exports.PropertyAttributesDtoOfficeAreaUnitEnum = exports.PropertyAttributesDtoWarehouseAreaUnitEnum = exports.PropertyAttributesDtoRetailAreaUnitEnum = exports.PropertyAttributesDtoFrontageUnitEnum = exports.PropertyAttributesDtoFloorAreaUnitEnum = exports.PropertyAttributesDtoLandAreaUnitEnum = void 0;
exports.instanceOfPropertyAttributesDto = instanceOfPropertyAttributesDto;
exports.PropertyAttributesDtoFromJSON = PropertyAttributesDtoFromJSON;
exports.PropertyAttributesDtoFromJSONTyped = PropertyAttributesDtoFromJSONTyped;
exports.PropertyAttributesDtoToJSON = PropertyAttributesDtoToJSON;
exports.PropertyAttributesDtoToJSONTyped = PropertyAttributesDtoToJSONTyped;
/**
 * @export
 */
exports.PropertyAttributesDtoLandAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoFloorAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoFrontageUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoRetailAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoWarehouseAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoOfficeAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoMezzanineAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * @export
 */
exports.PropertyAttributesDtoOtherAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * Check if a given object implements the PropertyAttributesDto interface.
 */
function instanceOfPropertyAttributesDto(value) {
    return true;
}
function PropertyAttributesDtoFromJSON(json) {
    return PropertyAttributesDtoFromJSONTyped(json, false);
}
function PropertyAttributesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'zoning': json['zoning'] == null ? undefined : json['zoning'],
        'bedrooms': json['bedrooms'] == null ? undefined : json['bedrooms'],
        'bathrooms': json['bathrooms'] == null ? undefined : json['bathrooms'],
        'toilets': json['toilets'] == null ? undefined : json['toilets'],
        'garages': json['garages'] == null ? undefined : json['garages'],
        'ensuites': json['ensuites'] == null ? undefined : json['ensuites'],
        'isLandHousePackage': json['isLandHousePackage'] == null ? undefined : json['isLandHousePackage'],
        'landArea': json['landArea'] == null ? undefined : json['landArea'],
        'landAreaUnit': json['landAreaUnit'] == null ? undefined : json['landAreaUnit'],
        'floorArea': json['floorArea'] == null ? undefined : json['floorArea'],
        'floorAreaUnit': json['floorAreaUnit'] == null ? undefined : json['floorAreaUnit'],
        'frontage': json['frontage'] == null ? undefined : json['frontage'],
        'frontageUnit': json['frontageUnit'] == null ? undefined : json['frontageUnit'],
        'propertyAge': json['propertyAge'] == null ? undefined : json['propertyAge'],
        'retailArea': json['retailArea'] == null ? undefined : json['retailArea'],
        'retailAreaUnit': json['retailAreaUnit'] == null ? undefined : json['retailAreaUnit'],
        'warehouseArea': json['warehouseArea'] == null ? undefined : json['warehouseArea'],
        'warehouseAreaUnit': json['warehouseAreaUnit'] == null ? undefined : json['warehouseAreaUnit'],
        'officeArea': json['officeArea'] == null ? undefined : json['officeArea'],
        'officeAreaUnit': json['officeAreaUnit'] == null ? undefined : json['officeAreaUnit'],
        'mezzanineArea': json['mezzanineArea'] == null ? undefined : json['mezzanineArea'],
        'mezzanineAreaUnit': json['mezzanineAreaUnit'] == null ? undefined : json['mezzanineAreaUnit'],
        'otherArea': json['otherArea'] == null ? undefined : json['otherArea'],
        'otherAreaUnit': json['otherAreaUnit'] == null ? undefined : json['otherAreaUnit'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
        'carPorts': json['carPorts'] == null ? undefined : json['carPorts'],
        'openParkingSpaces': json['openParkingSpaces'] == null ? undefined : json['openParkingSpaces'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'energyRating': json['energyRating'] == null ? undefined : json['energyRating'],
    };
}
function PropertyAttributesDtoToJSON(json) {
    return PropertyAttributesDtoToJSONTyped(json, false);
}
function PropertyAttributesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'zoning': value['zoning'],
        'bedrooms': value['bedrooms'],
        'bathrooms': value['bathrooms'],
        'toilets': value['toilets'],
        'garages': value['garages'],
        'ensuites': value['ensuites'],
        'isLandHousePackage': value['isLandHousePackage'],
        'landArea': value['landArea'],
        'landAreaUnit': value['landAreaUnit'],
        'floorArea': value['floorArea'],
        'floorAreaUnit': value['floorAreaUnit'],
        'frontage': value['frontage'],
        'frontageUnit': value['frontageUnit'],
        'propertyAge': value['propertyAge'],
        'retailArea': value['retailArea'],
        'retailAreaUnit': value['retailAreaUnit'],
        'warehouseArea': value['warehouseArea'],
        'warehouseAreaUnit': value['warehouseAreaUnit'],
        'officeArea': value['officeArea'],
        'officeAreaUnit': value['officeAreaUnit'],
        'mezzanineArea': value['mezzanineArea'],
        'mezzanineAreaUnit': value['mezzanineAreaUnit'],
        'otherArea': value['otherArea'],
        'otherAreaUnit': value['otherAreaUnit'],
        'highlights': value['highlights'],
        'carPorts': value['carPorts'],
        'openParkingSpaces': value['openParkingSpaces'],
        'yearBuilt': value['yearBuilt'],
        'energyRating': value['energyRating'],
    };
}
